module.exports = __webpack_public_path__ + "img/google-play-badge-us.91165cd0.png";